<template>
  <v-container
    fluid
    fill-height
    class="fallback-container d-flex align-center justify-center"
  >
    <v-row align="center" justify="center">
      <v-col cols="12" md="8" class="text-center">
        <v-icon
          :color="$vuetify.theme.themes.light.warning"
          size="80"
          class="mb-4"
        >
          mdi-alert-circle-outline
        </v-icon>
        <h1 class="mb-2 white--text">
          Página não disponível
        </h1>
        <p class="caption grey--text">
          Esta funcionalidade ainda não está disponível para a versão selecionada do sistema.
          <br />
          Tente novamente mais tarde ou entre em contato com o suporte.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'FallbackVersao',
}
</script>

<style scoped>
.fallback-container {
  background-image: url('~@/assets/imgs/estruturadas/background.svg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
}
</style>
